import React from 'react';
import SidebarHeader from './components/SidebarHeader';
import SidebarNav from './components/SidebarNav';
import SidebarRecentInquiries from './components/SidebarRecentInquiries';

/**
 * 애플리케이션의 메인 사이드바 컴포넌트.
 * 열림: w-72 전체 표시 / 닫힘(데스크톱): w-16 아이콘 레일 / 닫힘(모바일): 완전 숨김
 */
const AppSidebar = ({
    isOpen,
    activeTab,
    setActiveTab,
    viewMode,
    currentUser,
    recentInquiries,
    onSelectInquiry,
    onDeleteInquiry,
    onNewChat,
    onToggleSidebar,
    isHistoryLoading
}) => {
    return (
        <>
            {/* 모바일 전용 배경막 */}
            <div
                className={`fixed inset-0 bg-black/20 backdrop-blur-[2px] z-40 transition-opacity duration-300 md:hidden ${
                    isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
                onClick={onToggleSidebar}
            />

            <aside className={`
                fixed md:fixed md:top-[64px] inset-y-0 left-0 h-screen md:h-[calc(100vh-64px)]
                overflow-hidden bg-[#f0f4f9] border-gray-200/50
                transition-all duration-300 ease-in-out
                flex flex-col z-50 md:z-20
                ${isOpen
                    ? 'translate-x-0 w-72 border-r'
                    : '-translate-x-full w-0 md:translate-x-0 md:w-16 md:border-r'
                }
            `}>
                <div className="flex flex-col h-full" style={{ padding: isOpen ? '16px' : '16px 8px' }}>
                    <SidebarHeader
                        onNewChat={onNewChat}
                        setActiveTab={setActiveTab}
                        isOpen={isOpen}
                        onToggleSidebar={onToggleSidebar}
                    />

                    <SidebarNav
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        isOpen={isOpen}
                    />

                    <SidebarRecentInquiries
                        recentInquiries={recentInquiries}
                        isHistoryLoading={isHistoryLoading}
                        onSelectInquiry={onSelectInquiry}
                        onDeleteInquiry={onDeleteInquiry}
                        setActiveTab={setActiveTab}
                        viewMode={viewMode}
                        currentUser={currentUser}
                        isOpen={isOpen}
                    />
                </div>
            </aside>
        </>
    );
};

export default AppSidebar;
